import { Menu } from '@arco-design/web-react';
import { Outline } from './outline';

const SubMenu = Menu.SubMenu;
const MenuItem = Menu.Item;

function Navbar(props: any) {
  const { titles, activeIndex, onClick } = props;

  const navContentItems = document.querySelectorAll(
    '.vchart-example-filter-content-item'
  );

  const navTitleItems = document.querySelectorAll(
    '.vchart-example-filter-title-item'
  );

  navTitleItems.forEach((navTitleItem) => {
    navTitleItem.addEventListener('click', () => {
      removeSelected();
    });
  });

  function removeSelected() {
    navContentItems.forEach((navContentItem) => {
      navContentItem.classList.remove('selected');
    });
  }

  return (
    <div className="vchart-example-filter-title">
      {titles.map((title: string, index: number) => {
        return (
          <div
            key={index}
            className={
              index === activeIndex
                ? 'active vchart-example-filter-title-item'
                : 'vchart-example-filter-title-item'
            }
            onClick={() => onClick(index, '')}
          >
            {title}
          </div>
        );
      })}
    </div>
  );
}

function Content(props: any) {
  const { activeIndex, contents, onClick, keywordsMap } = props;

  const navItems = document.querySelectorAll(
    '.vchart-example-filter-content-item'
  );

  navItems.forEach((navItem) => {
    navItem.addEventListener('click', () => {
      removeSelected();
      navItem.classList.add('selected');
    });
  });

  function removeSelected() {
    navItems.forEach((navItem) => {
      navItem.classList.remove('selected');
    });
  }

  return (
    <div className="vchart-example-filter-content">
      {contents[activeIndex].map((content: string) => {
        return (
          <div
            className="vchart-example-filter-content-item"
            onClick={() => onClick(content)}
          >
            {keywordsMap[content] ?? content}
          </div>
        );
      })}
    </div>
  );
}

export function ExampleFilter(props: any) {
  const {
    activeIndex,
    titles,
    contents,
    handleNavbarClick,
    handleNavContentClick,
    chartGroups,
    siteType,
    demoType,
  } = props;

  return (
    <div className="example-filter-component">
      <Outline
        titles={titles}
        contents={contents}
        handleNavContentClick={handleNavContentClick}
        chartGroups={chartGroups}
        siteType={siteType}
        demoType={demoType}
      />
      {/* <Navbar
        titles={titles}
        activeIndex={activeIndex}
        onClick={handleNavbarClick}
      />
      <Content
        activeIndex={activeIndex}
        contents={contents}
        onClick={handleNavContentClick}
        keywordsMap={keywordsMap}
      /> */}
    </div>
  );
}
